import SquadBuilder from '@/components/events/SquadBuilder'
import type { Event } from '@/components/events/types'

export interface SignUp {
  user_id: string
  name: string
  class_name: string
  class_emote_id?: string | null
  spec_name?: string | null
  spec_emote_id?: string | null
  is_active: boolean
  is_bench?: boolean
  class_emoji?: string
  avatar_url?: string | null
}

interface RosterConfigProps {
  threadId: string
  eventId: string
  signUps: SignUp[]
  // Operators may send the roster to Discord; the strategy team only builds it.
  canSend?: boolean
}

export default function RosterConfig({ threadId, eventId, signUps, canSend = true }: RosterConfigProps) {
  const event: Event = {
    id: eventId,
    title: '',
    date: '',
    channel_id: threadId,
    channel_name: '',
    start_time: 0,
    closing_time: 0,
    image_url: null,
    active_count: signUps.filter(s => s.is_active).length,
    roster_count: 0,
    sign_ups: signUps.map(s => ({
      user_id: s.user_id,
      name: s.name,
      class_name: s.class_name,
      class_emote_id: s.class_emote_id ?? null,
      spec_name: s.spec_name ?? null,
      spec_emote_id: s.spec_emote_id ?? null,
      is_active: s.is_active,
      is_bench: s.is_bench,
      class_emoji: s.class_emoji,
      avatar_url: s.avatar_url ?? null,
      in_roster: false,
    })),
  }

  return (
    <SquadBuilder
      event={event}
      apiBase={`/api/matches/${threadId}`}
      preset="full"
      canSend={canSend}
    />
  )
}
